export default "__VITE_ASSET__CCckm57O__"